"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipPopover = void 0;
const react_1 = __importStar(require("react"));
const helpers_1 = require("../../../helpers");
const Icon_1 = require("../../../Icon");
const StackView_1 = require("../../../StackView");
const Text_1 = require("../../../Text");
const TooltipPopover_styles_1 = require("./TooltipPopover.styles");
exports.TooltipPopover = (0, helpers_1.createUIElement)('TooltipPopover', ({ className, iconSrc, icon, text, title, renderContent, maxWidth, style, ['data-selector-id']: initialDataSelectorId }, ref) => {
    const dataSelectorId = (0, react_1.useMemo)(() => initialDataSelectorId || 'tooltip-popover', [initialDataSelectorId]);
    const innerIconDataSelectorId = (0, react_1.useMemo)(() => `${dataSelectorId}-icon`, [dataSelectorId]);
    const textDataSelectorId = (0, react_1.useMemo)(() => `${dataSelectorId}-text`, [dataSelectorId]);
    const titleDataSelectorId = (0, react_1.useMemo)(() => `${dataSelectorId}-title`, [dataSelectorId]);
    const hasIcon = (0, react_1.useMemo)(() => Boolean(iconSrc || icon), [icon, iconSrc]);
    const innerIconSrc = (0, react_1.useMemo)(() => iconSrc || icon || '', [icon, iconSrc]);
    if (renderContent) {
        return (react_1.default.createElement(TooltipPopover_styles_1.StyledTooltipPopover, { ref: ref, testId: dataSelectorId, direction: StackView_1.STACK_DIRECTION.column, gap: StackView_1.STACK_GAP.s, style: style, maxWidth: maxWidth, className: className }, renderContent()));
    }
    return (react_1.default.createElement(TooltipPopover_styles_1.StyledTooltipPopover, { ref: ref, testId: dataSelectorId, direction: StackView_1.STACK_DIRECTION.column, gap: StackView_1.STACK_GAP.s, style: style, maxWidth: maxWidth, className: className },
        title && (react_1.default.createElement(StackView_1.StackView, { direction: StackView_1.STACK_DIRECTION.row, gap: StackView_1.STACK_GAP.s },
            hasIcon && (react_1.default.createElement(TooltipPopover_styles_1.StyledTooltipPopoverInnerIcon, { "data-selector-id": innerIconDataSelectorId, src: innerIconSrc, size: Icon_1.ICON_SIZES.s })),
            title && (react_1.default.createElement(TooltipPopover_styles_1.StyledTooltipPopoverText, { "data-selector-id": titleDataSelectorId, size: Text_1.TEXT_SIZE.s, weight: Text_1.TEXT_WEIGHT.bold }, title)))),
        text && (react_1.default.createElement(StackView_1.StackView, { direction: StackView_1.STACK_DIRECTION.row, gap: StackView_1.STACK_GAP.s },
            hasIcon && !title && (react_1.default.createElement(TooltipPopover_styles_1.StyledTooltipPopoverInnerIcon, { "data-selector-id": innerIconDataSelectorId, src: innerIconSrc, size: Icon_1.ICON_SIZES.s })),
            text && (react_1.default.createElement(TooltipPopover_styles_1.StyledTooltipPopoverText, { "data-selector-id": textDataSelectorId, whitespace: Text_1.TEXT_WHITE_SPACE.preWrap, size: Text_1.TEXT_SIZE.s }, text))))));
});
//# sourceMappingURL=TooltipPopover.js.map